import { Model, RailsFormat } from "./model"
import * as moment from "moment"
import { Contact } from "./contact";
import { Window } from "./window";
import { Course } from "./course";

export class TutorAllocation extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public windowIds?: number[],
    public courseIds?: number[],
    public contact: Contact = null,
    public windows: Window[] = [],
    public courses: Course[] = [],
  ) {
    super()
  }

  public static clone(obj: any) {
    const ta = new this()

    if (obj.id) { ta.id = obj.id }
    if (obj.contactId) { ta.contactId = obj.contactId }
    if (obj.windowIds) { ta.windowIds = obj.windowIds }
    if (obj.courseIds) { ta.courseIds = obj.courseIds }

    if (obj.contact) { ta.contact = Contact.clone(obj.contact) }

    if (obj.windows && obj.windows.length > 0) {
      ta.windows = obj.windows.map((w: any) => Window.clone(w))
    }

    if (obj.courses && obj.courses.length > 0) {
      ta.courses = obj.courses.map((c: any) => Course.clone(c))
    }

    return ta
  }

  serializeForRails() {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/tutor-allocation.ts